// extracted by mini-css-extract-plugin
module.exports = {"container":"resetPassRequest_container__1l6F4","info":"resetPassRequest_info__2elSJ","button":"resetPassRequest_button__2l3fq"};